export default __webpack_public_path__ + "static/media/faq-plus.99a3b360.svg";